/* eslint-disable no-undef,no-console */
import Raven from 'raven-js';

const isProduction = ENVIRONMENT === 'production';

export default class Logger {
    static info(message) {
        if (!isProduction) {
            console.log(message);
        }
    }

    static warn(message, options) {
        if (!isProduction) {
            console.warn(message);
        } else {
            Raven.captureMessage(message, options);
        }
    }

    static error(message, options) {
        if (isProduction) {
            Raven.captureException(message, options);
        }

        console.error(message);
    }
}
